import { useId } from "react";

import { SvgIconProps } from "@mui/material";

type StrippedCircleProps = SvgIconProps;

export const StrippedCircle = ({
  fill = "currentColor",
  height = 14,
  width = 14,
  ...props
}: StrippedCircleProps) => {
  // When you have multiple instances of this icon on the page with different colors, if they all reference the same pattern ID they all end up using the same color (the last one rendered).
  // Creating a unique ID revents the issue.
  const uniqueId = useId();
  const stripesId = `stripes-${uniqueId}`;
  const clipPathId = `circle-clip-${uniqueId}`;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <pattern
          id={stripesId}
          patternUnits="userSpaceOnUse"
          width="6"
          height="6"
          patternTransform="rotate(45)"
        >
          <rect width="3" height="6" fill={fill} />
        </pattern>
        <clipPath id={clipPathId}>
          <circle cx="10" cy="10" r="8" />
        </clipPath>
      </defs>
      <rect
        width="20"
        height="20"
        fill={`url(#${stripesId})`}
        clipPath={`url(#${clipPathId})`}
      />
      <circle cx="10" cy="10" r="8" fill="none" stroke={fill} strokeWidth="2" />
    </svg>
  );
};
